import { reducers } from "@insite/client-framework/Store/Reducers";
import jobQuotesReducer, { JobQuotesActions } from "@toolkit/Extensions/Store/Data/JobQuotes/JobQuotesReducer";
import getExtensionPropsFromCombinedReducer from "@toolkit/Framework/Common/Utilities/redux/getExtensionPropsFromCombinedReducer";
import { combineReducers } from "redux";

const dataReducer = combineReducers({
    ...getExtensionPropsFromCombinedReducer(reducers.data),
    jobQuotes: jobQuotesReducer,
});

export type DataActions = JobQuotesActions;

export default dataReducer;
